import { useState } from 'react';
import { toast } from 'sonner';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { ApiRequestError } from '@/lib/api';
import { useDeleteFleetDocument } from '@/products/fleet/features/use-fleet';

export function FleetDocumentDeleteButton({
  documentId,
  fileName,
  subject,
}: {
  documentId: string;
  fileName: string;
  subject: string;
}) {
  const remove = useDeleteFleetDocument();
  const [open, setOpen] = useState(false);

  async function confirm() {
    try {
      await remove.mutateAsync(documentId);
      setOpen(false);
      toast.success(`„${fileName}“ wurde gelöscht.`);
    } catch (error) {
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : 'Das Dokument konnte nicht gelöscht werden.',
      );
    }
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="min-h-11"
        onClick={() => setOpen(true)}
      >
        Löschen
      </Button>
      <AlertDialog
        open={open}
        onOpenChange={(next) => {
          if (!next && !remove.isPending) {
            setOpen(false);
          }
        }}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>„{fileName}“ löschen?</AlertDialogTitle>
            <AlertDialogDescription>
              Das Dokument {subject} wird entfernt. Der Datenbankeintrag und die gespeicherte Datei
              werden zusammen gelöscht. Die Zuordnung, die Meldung oder die Kontrolle bleibt
              bestehen.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={remove.isPending}>Abbrechen</AlertDialogCancel>
            <Button
              type="button"
              variant="destructive"
              className="min-h-11"
              disabled={remove.isPending}
              onClick={() => void confirm()}
            >
              {remove.isPending ? 'Wird gelöscht …' : 'Löschen'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
